import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetDocumentMarkersQueryVariables = Types.Exact<{
  documentId: Types.Scalars['ID']['input'];
}>;


export type GetDocumentMarkersQuery = { __typename?: 'Query', documentMarkers: Array<{ __typename?: 'DocumentMarker', id?: string | null, name: string, comments: string, start: number, duration?: number | null, deleted: boolean, frameCommentId?: string | null }> };


export const GetDocumentMarkers = /*#__PURE__*/ gql`
    query GetDocumentMarkers($documentId: ID!) {
  documentMarkers(documentId: $documentId) {
    id
    name
    comments
    start
    duration
    deleted
    frameCommentId
  }
}
    ` as unknown as DocumentNode<GetDocumentMarkersQuery, GetDocumentMarkersQueryVariables>;

          

          export const useGetDocumentMarkersQuery = (options?:QueryHookOptions<GetDocumentMarkersQuery, GetDocumentMarkersQueryVariables>) => useQuery(GetDocumentMarkers, options);

          

          export type GetDocumentMarkersQueryOptions = QueryHookOptions<GetDocumentMarkersQuery, GetDocumentMarkersQueryVariables>;

          

          export const useGetDocumentMarkersLazyQuery = (options?:LazyQueryHookOptions<GetDocumentMarkersQuery, GetDocumentMarkersQueryVariables>) => useLazyQuery(GetDocumentMarkers, options);

          

          export type GetDocumentMarkersQueryResult = ReturnType<typeof useGetDocumentMarkersQuery>;

          
